var map = {
	"./icon1.svg": [
		32
	],
	"./icon2.svg": [
		33
	],
	"./icon3.svg": [
		34
	],
	"./intro.jpg": [
		31
	],
	"./lion.png": [
		67,
		7
	],
	"./svg-1.svg": [
		68,
		3
	],
	"./svg-2.svg": [
		69,
		4
	],
	"./svg-3.svg": [
		70,
		5
	],
	"./svg-4.svg": [
		71,
		6
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 44;
module.exports = webpackAsyncContext;